import React, { useEffect } from 'react';
import { APP_ROUTES } from '../routes/AppRouter';
import { useNavigate } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import ContentLoading from '../components/ContentLoading';

export default function Home (): React.ReactElement {

  const navigate = useNavigate();
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      navigate(APP_ROUTES.searchSav);
    }
  }, [initialized, keycloak.authenticated, navigate]);
  
  return (
    <ContentLoading/>
  );
}